import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { IntercomProvider } from "react-use-intercom";
import CacheBuster from "react-cache-buster";
import { ErrorBoundary } from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";

import { SentryInitialiser } from "@/services/Sentry";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";

import PageLoader from "./components/Application/PageLoader";
import { Error } from "./components/Error";
import { StandaloneConnectBootstrap } from "./components/StandaloneConnectBootstrap";
import { PostHogOptions } from "./services/postHog";
import { initializeObservability } from "./services/Observability";
import { VITE_INTERCOM_APP_ID } from "./constants";
import { MiddlewareProvider } from "./store/MiddlewareContext";
import PackageJson from "../package.json";
import "@fontsource/cabin";
// import { Auth0Provider } from "@auth0/auth0-react";

// ----------------------------------------------------------------------
const isProduction = import.meta.env.NODE_ENV === "production";
initializeObservability();
// const onRedirectCallback = (appState) => {
//   history.push(
//     appState && appState.returnTo ? appState.returnTo : window.location.pathname
//   );
// };

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <CacheBuster
        currentVersion={PackageJson?.version}
        isEnabled={isProduction} //If false, the library is disabled.
        isVerboseMode={true} //If true, the library writes verbose logs to console.
        loadingComponent={<PageLoader></PageLoader>} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      >
        <IntercomProvider appId={VITE_INTERCOM_APP_ID}>
          <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={PostHogOptions}>
            <SentryInitialiser />
            <ErrorBoundary fallback={<Error />}>
              <StandaloneConnectBootstrap>
                <MiddlewareProvider>
                  <App />
                </MiddlewareProvider>
              </StandaloneConnectBootstrap>
            </ErrorBoundary>
          </PostHogProvider>
        </IntercomProvider>
      </CacheBuster>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root"),
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
